// eslint-disable-next-line import/prefer-default-export
export const enrichParamsWithSemanticFlags = (params, { semanticSearchIncluded, semanticResultName, textQuery } = {}) => ({
  ...params,
  ...(semanticSearchIncluded !== undefined && { semanticSearchIncluded }),
  ...(semanticResultName && { semanticResultName }),
  ...(textQuery && { textQuery }),
});
